import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\'bold\'>\n  {{get @record @propertyName}}\n</div>")